var exports = {
  "J9": "x31de4314--4f54e9--pagination-section",
  "X$": "x31de4314--4f54e9--pagination",
  "Uo": "x31de4314--4f54e9--buttons",
};

module.exports = exports;
